import CloseButton from 'components/buttons'
import React, { useState } from 'react'

const Banner = () => {
  const [cookieState, setCookie] = useState(
    localStorage.getItem('dismissedSplunkOnCallBanner') === 'true'
  )

  const dismissBanner = () => {
    localStorage.setItem('dismissedSplunkOnCallBanner', 'true')
    setCookie(true)
  }
  return !cookieState ? (
    <div
      data-ext='vo.splunk-on-call-banner'
      className='header--splunk-on-call-banner'
    >
      VictorOps is now Splunk On-Call!
      <CloseButton onClick={dismissBanner} />
    </div>
  ) : null
}
export default Banner
